import React from 'react'

export default function Home() {
    return (
        <div className="imprint">
            <div className='collaborate'>
                <p>
                    I am a freelance full-stack software developer since 2006.
                </p>
                <p>
                    I am always interested in new projects.
                </p>
                <p>
                    My tech stack is:
                </p>
                <ul>
                    <li>Ruby on Rails</li>
                    <li>React</li>
                    <li>React Three Fiber/ Three.js</li>
                    <li>Blender, Phython</li>
                    <li>Linux</li>
                </ul>    
                <p>
                    Contact me at <a href="mailto:grgr@3motic.com">grgr@3motic.com</a>
                </p>
            </div>
        </div>
    )
}


